"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../../../core/collapse"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
var _bibDetails = _interopRequireDefault(require("../../../../core/bib-details"));
var _nonRankedPaddler = _interopRequireDefault(require("./non-ranked-paddler"));
var _eligibleRacesTable = _interopRequireDefault(require("./eligible-races-table"));
var _submit = _interopRequireDefault(require("../../../../core/submit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Entry Received");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Contact Email Address");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Class");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Ranking Division");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Ranking Bib number");
class AddPostalEntry extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isOpened: false,
      newEntry: {
        classRef: null,
        classDivisionID: null,
        cseBibID: null,
        entryReceivedDate: new Date().toISOString().split('T')[0],
        contactEmail: null,
        // fields used for non-ranked paddlers
        startListBib: 999,
        bibName: null,
        paddlerClubID: null,
        yearOfBirth: null,
        hasPaid: null
      },
      isEntered: false,
      hasErrors: {},
      showRaces: false
    });
    // Note when a field is changed we reset hasPaid and showRaces
    // This forces user to resubmit so that we can re-check values and redisplay races
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newEntry: {
          ...this.state.newEntry,
          [field]: value,
          hasPaid: null
        },
        showRaces: false
      });
    });
    _defineProperty(this, "_hasPaid", e => {
      this.setState({
        newEntry: {
          ...this.state.newEntry,
          hasPaid: true
        }
      });
    });
    _defineProperty(this, "_hasNotPaid", e => {
      this.setState({
        newEntry: {
          ...this.state.newEntry,
          hasPaid: false
        }
      });
    });
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.setState({
        showRaces: true
      });
    });
  }
  render() {
    // TODO: make this return the correct date when local time is BST, it'll only be wrong for one hour in the middle
    //       of the night.
    const today = new Date().toISOString().split('T')[0];
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Entry' : 'Add Postal Entry')), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      style: {
        marginTop: 14
      },
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Date",
      name: "entryReceivedDate",
      value: this.state.newEntry.entryReceivedDate,
      onChange: this._setValue.bind(this, 'entryReceivedDate'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "contactEmail",
      value: this.state.newEntry.contactEmail,
      onChange: this._setValue.bind(this, 'contactEmail'),
      required: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "class",
      value: this.state.newEntry.classRef,
      onChange: this._setValue.bind(this, 'classRef'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "ClassDivisions",
      includeCannotEnterOnline: true,
      classRef: this.state.newEntry.classRef,
      value: this.state.newEntry.classDivisionID,
      onChange: this._setValue.bind(this, 'classDivisionID'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "BibNumbers",
      classDivisionID: this.state.newEntry.classDivisionID,
      yearID: +this.props.yearID,
      value: this.state.newEntry.cseBibID,
      onChange: this._setValue.bind(this, 'cseBibID'),
      clearable: false,
      withNotRanked: true
    }))), !(this.state.newEntry.classDivisionID !== null && this.state.newEntry.cseBibID === 0) ? null : /*#__PURE__*/_react.default.createElement(_nonRankedPaddler.default, {
      yearID: +this.props.yearID,
      newEntry: this.state.newEntry,
      setValue: this._setValue
    }), !(this.state.newEntry.classDivisionID && (this.state.newEntry.cseBibID || this.state.newEntry.cseBibID === 0 && this.state.newEntry.bibName) && !this.state.showRaces) ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 col-sm-6"
    }, /*#__PURE__*/_react.default.createElement(_submit.default, {
      type: "primary",
      block: true,
      onClick: this._hasPaid
    }, "Has Paid")), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 col-sm-6"
    }, /*#__PURE__*/_react.default.createElement(_submit.default, {
      type: "danger",
      block: true,
      onClick: this._hasNotPaid
    }, "Has Not Paid"))))), !this.state.showRaces ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card-footer"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: 'pull-xs-right ' + (this.state.newEntry.hasPaid ? 'text-danger' : 'text-info')
    }, this.state.newEntry.hasPaid ? 'PAID' : 'NOT PAID'), this.state.newEntry.cseBibID > 0 ? /*#__PURE__*/_react.default.createElement(_bibDetails.default, {
      yearID: +this.props.yearID,
      cseBibID: this.state.newEntry.cseBibID
    }) : this.state.newEntry.cseBibID === 0 && this.state.newEntry.bibName ? /*#__PURE__*/_react.default.createElement("h4", null, "Non-Ranked Paddler ", this.state.newEntry.bibName) : null, /*#__PURE__*/_react.default.createElement(_eligibleRacesTable.default, {
      yearID: +this.props.yearID,
      competitionSlug: this.props.competitionSlug,
      newEntry: this.state.newEntry
    }))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = AddPostalEntry;